import ApprovePaymentPlanError from './ApprovePaymentPlanError';
class InvalidTwoFactorCode extends ApprovePaymentPlanError {
    confirmationCode;
    constructor(confirmationCode, options) {
        super('Two factor code is invalid', options);
        this.confirmationCode = confirmationCode;
    }
}
export default InvalidTwoFactorCode;
